import styled from 'styled-components';

export const Image = styled.img`
    width: 80vw;
    max-width: 800px;
`;
